import * as React from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';
import { DynamicPhoneLinkWrapper } from '../../../components/DynamicPhoneLinkWrapper';
import { PhoneLinkQRCode } from '../../../components/PhoneLinkQRCode';
import { NewbuildingDynamicPhone } from '../../NewbuildingDynamicPhone';
import { INewbuildingBuilder } from '../../../types/newbuilding/builder';
import { INewbuildingSeller } from '../../../types/newbuilding/seller';
import { getFormattedPhone, getPhoneString } from '../../../utils/phone';

interface IPhoneContainerProps {
  contact: INewbuildingBuilder | INewbuildingSeller;
  placeType: string;
}

export const PhoneContainer = ({ contact, placeType }: IPhoneContainerProps) => {
  const notFormattedPhone = React.useMemo(() => getPhoneString(contact.phone), [contact]);
  const formattedPhone = React.useMemo(() => getFormattedPhone(contact.phone), [contact]);

  if (contact.dynamicCalltracking?.siteBlockId) {
    return (
      <UIText2 fontWeight="bold">
        <NewbuildingDynamicPhone
          placeType={placeType}
          siteBlockId={contact.dynamicCalltracking.siteBlockId}
          notFormattedPhone={notFormattedPhone}
          phoneNumber={formattedPhone}
        />
      </UIText2>
    );
  }

  return (
    <DynamicPhoneLinkWrapper>
      <a href={notFormattedPhone as string} data-testid="PhoneLink">
        <UIHeading3>{formattedPhone}</UIHeading3>
      </a>
      <PhoneLinkQRCode phoneLink={notFormattedPhone as string} formattedPhone={formattedPhone} />
    </DynamicPhoneLinkWrapper>
  );
};
